<template>
  <div>
    <validation-observer :ref="`${code}-validator`">
      <GeneralHistory
        :list="services"
        v-model="model.relatedServices"
        :is-read-only="isReadOnly"
      />
      <SocioEmotionalSkills
        :questions="questions.socioEmotionalSkills"
        v-model="model.socioEmotionalSkillsModel"
        :is-read-only="isReadOnly"
      />
      <DataAccessATSchool
        :questions="questions.dataAccessATSchool"
        v-model="model.dataAccessATSchoolModel"
        :is-read-only="isReadOnly"
      />
    </validation-observer>
  </div>
</template>
<script>
import GeneralHistory from './components/tab-IIIb/GeneralHistory.vue'
import SocioEmotionalSkills from './components/tab-IIIb/SocioEmotionalSkills.vue'
import DataAccessATSchool from './components/tab-IIIb/DataAccessATSchool.vue'
import referralService from '@/services/api/referralsandequipments.api'
import questionnaireQuestionSection from '@/utils/constants/questionnaireQuestionSection'
import mixAlert from '@/mixins/alert.mixin'
import TABS from '@/utils/constants/evaluationTabs'
export default {
  name: 'Tab-IIIb',
  mixins: [mixAlert],
  components: {
    GeneralHistory,
    SocioEmotionalSkills,
    DataAccessATSchool,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({
        referralInfo: {},
      }),
    },
  },
  data: () => ({
    services: [],
    questions: {
      socioEmotionalSkills: [],
      dataAccessATSchool: [],
    },
    value: {
      socioEmotionalSkillsModel: {
        additionalRemarks: null,
        questions: [],
      },
      dataAccessATSchoolModel: {
        otherEquipmentSchool: null,
        additionalRemarks: null,
        questions: [],
      },
      relatedServices: {
        adaptedOrthopedicEquipment: null,
        parentExpectations: null,
        studentExpectations: null,
        notApply: null,
      },
    },
  }),
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  async mounted() {
    await this.initData()
  },
  methods: {
    async initData() {
      await this.getServicesEvaluations()
      await this.getInfo()
      this.$emit('loaded', TABS.IIIb)
    },
    async validate() {
      const valid = await this.$refs[`${this.code}-validator`].validate()
      return {
        valid,
        message: valid
          ? ''
          : 'Información Relevante del Historial General, al Proceso de Evaluación en AT',
      }
    },
    async getServicesEvaluations() {
      const { data } = await referralService.getServicesEvaluations(
        this.data.referralInfo.peiId
      )
      this.services = data
    },
    async getQuestionaty(id, sectionId) {
      const { data } = await referralService.getQuestionnaire(id, sectionId)
      return data
    },
    async save(showMessage = true) {
      const data = {
        studentExpectations:
          this.value.relatedServices.studentExpectations || null,
        parentExpectations:
          this.value.relatedServices.parentExpectations || null,
        adaptedOrthopedicEquipment:
          this.value.relatedServices.adaptedOrthopedicEquipment || null,
        notApply: this.value.relatedServices.notApply || false,
        socioEmotionalSkillsAdditionalRemarks:
          this.value.socioEmotionalSkillsModel.additionalRemarks || null,
        dataAccessATSchoolOtherEquipmentSchool:
          this.value.dataAccessATSchoolModel.otherEquipmentSchool || null,
        dataAccessATSchoolAdditionalRemarks:
          this.value.dataAccessATSchoolModel.additionalRemarks || null,
        answers: [
          ...new Set(this.value.socioEmotionalSkillsModel.questions || []),
          ...new Set(this.value.dataAccessATSchoolModel.questions || []),
        ],
      }
      referralService
        .saveRelevantGeneralHistoryInformation(this.referralId, data)
        .then(async () => {
          if (showMessage) {
            this.ShowToast(
              'Éxito',
              'Información ha sido guardada exitosamente.',
              'success'
            )
          }
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error')
        })
    },
    async getInfo() {
      const q = await this.getQuestionaty(
        this.referralId,
        questionnaireQuestionSection.DestrezasSocioemocionales
      )
      const q2 = await this.getQuestionaty(
        this.referralId,
        questionnaireQuestionSection.DatosAccesoATEscuela
      )

      this.questions.socioEmotionalSkills = q.length ? q[0].questions : []
      this.questions.dataAccessATSchool = q2.length ? q2[0].questions : []

      const socioEmotionalQuestionIds = this.questions.socioEmotionalSkills.map(
        (x) => x.id
      )
      const dataAccessATSchoolQuestionIds = this.questions.dataAccessATSchool.map(
        (x) => x.id
      )

      const { data } = await referralService.getTabIIIbInfo(this.referralId)
      this.value = {
        socioEmotionalSkillsModel: {
          additionalRemarks: data.socioEmotionalSkillsAdditionalRemarks || null,
          questions:
            data.answers.filter((x) =>
              socioEmotionalQuestionIds.includes(x.questionId)
            ) || [],
        },
        dataAccessATSchoolModel: {
          otherEquipmentSchool:
            data.dataAccessATSchoolOtherEquipmentSchool || null,
          additionalRemarks: data.dataAccessATSchoolAdditionalRemarks || null,
          questions:
            data.answers.filter((x) =>
              dataAccessATSchoolQuestionIds.includes(x.questionId)
            ) || [],
        },
        relatedServices: {
          adaptedOrthopedicEquipment: data.adaptedOrthopedicEquipment || null,
          parentExpectations: data.parentExpectations || null,
          studentExpectations: data.studentExpectations || null,
          notApply: data.notApply || null,
        },
      }
    },
  },
  watch: {
    questions: {
      immediate: true,
      handler(value, oldValue) {
        if (value !== oldValue) {
          this.questions = value
        }
      },
    },
  },
}
</script>
<style lang="scss"></style>
